import React, { useContext } from 'react'
import { AuthContext } from '../contexts/AuthContext'
import { useMyProfile } from '../hooks/useMyProfile'
import Sidebar from './Sidebar';

const Header = () => {
  const { isAuthenticated, isLoading } = useContext(AuthContext)
  const {profile} = useMyProfile();

  return (!isLoading && isAuthenticated)
  ?(
    <header className="header-panel">
      <button className="profile-button"></button>
      <h1>{!!profile ? profile.name : '--'}</h1>
      <Sidebar />
    </header>
  )
  : null
}

export default Header